import React, { createContext, useContext, useState } from 'react';

const StreamingContext = createContext(null);

export function useStreaming() {
    return useContext(StreamingContext);
}

export default function StreamingProvider(props) {
    const [streamingContext, setStreamingContext] = useState({
        streamingId: null,
        streamingMatchId: null,
        streamingProps: null,
        toggleStreamingId: function(streamingProps,id,matchId) {
            setStreamingContext(prev => {
                return  {
                    ...prev,
                    streamingId: prev.streamingId == id ? null : id,
                    streamingMatchId: matchId,
                    streamingProps: streamingProps
                }
            });
        }
    });

    return (
        <StreamingContext.Provider value={streamingContext}>
            {props.children}
        </StreamingContext.Provider>
    );
}
